import { useEffect, useRef } from 'react';
import { useAmplitudeEvents } from '@/utils/amplitudeEvents';

export const useSearchAnalytics = ({
  enable,
  guests,
  checkin,
  checkout,
  isLoading,
  resultsCount,
}: {
  enable: boolean;
  guests: string | null;
  checkin: string | null;
  checkout: string | null;
  isLoading: boolean;
  resultsCount: number;
}) => {
  const { trackSearchResultDisplayed } = useAmplitudeEvents();
  const eventKeyRef = useRef<string>('');
  const wasLoadingRef = useRef<boolean>(true);

  useEffect(() => {
    if (!enable) return;

    const key = `${guests ?? ''}-${checkin ?? ''}-${checkout ?? ''}`;

    if (
      wasLoadingRef.current &&
      !isLoading &&
      (checkin || checkout || guests)
    ) {
      if (eventKeyRef.current !== key) {
        trackSearchResultDisplayed(resultsCount);
        eventKeyRef.current = key;
      }
    }

    wasLoadingRef.current = isLoading;
  }, [
    enable,
    guests,
    checkin,
    checkout,
    isLoading,
    resultsCount,
    trackSearchResultDisplayed,
  ]);
};
